module.exports = __webpack_public_path__ + "media/images/gitlab-aa80d8bc8c5b2624c6eec8a04e206cba.png";